module.exports = __webpack_public_path__ + "img/tech.b4fef548.png";